var CTA_Actions = {
  quoteNowAction: function quoteNowAction() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  },
  scrollnClickCtaAction: function scrollnClickCtaAction(dataAuthId) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    var element = document.querySelector("[data-aut-id=\"".concat(dataAuthId, "\"]"));
    element.click();
  }
};
export default CTA_Actions;